export enum InvoiceState {
    pending = 1,
    payed = 2,
    lateBill = 3,
    cancel = 4
}
